import { Input as AntInput, Select as AntSelect } from 'antd';
import { InputProps } from 'antd/lib/input';
import { TextAreaProps } from 'antd/lib/input/TextArea';
import { SelectProps } from 'antd/lib/select';
import styled from 'styled-components';

const { TextArea: AntTextArea } = AntInput;

export const EventInfoCardContainer = styled.div`
  display: flex;
  gap: 16px;
  flex-direction: column;
`;

export const EventTitle = styled.span`
  width: 100%;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  display: flex;
  align-items: center;
  letter-spacing: -0.02em;
  padding: 8px 0;
`;

export const EventInfoContainer = styled.div`
  padding: 0 8px;
  display: flex;
  gap: 4px;
  flex-direction: column;
`;

export const EventInfoName = styled.span`
  font-weight: 700;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: -0.01em;
  color: rgba(0, 0, 0, 0.45);
  padding: 6px 0;
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  margin-right: 8px;
`;

export const EventInfoWrapper = styled.div`
  display: flex;

  .emp-ant-input::placeholder {
    color: rgba(0, 0, 0, 0.45);
  }
`;

export const StyledAntInput = styled(AntInput)<InputProps>`
  & {
    border-radius: 3px;
    border-color: rgba(0, 0, 0, 0.15) !important;
    color: rgba(0, 0, 0, 0.88) !important;
    padding: 4px 6px;
    height: 28px;
    letter-spacing: -0.01em;
  }
`;

export const StyledAntTextArea = styled(AntTextArea)<TextAreaProps>`
  && {
    border-radius: 3px;
    border-color: rgba(0, 0, 0, 0.15) !important;
    color: rgba(0, 0, 0, 0.88) !important;
    padding: 8px;
    font-family: Roboto, sans-serif;
    line-height: 20px;
  }
`;

export const StyledAntSelect = styled(AntSelect)<SelectProps>`
  && {
    width: 100%;
    color: rgba(0, 0, 0, 0.88);

    .emp-ant-select-selector {
      border-radius: 3px;
      border-color: rgba(0, 0, 0, 0.15);
      padding: 4px 6px;
      height: 28px;
      display: flex;
      align-items: center;
    }

    .emp-ant-select-selection-item {
      line-height: 20px;
      height: 20px;
      letter-spacing: -0.01em;
    }
  }
`;
